/**
 * @generated SignedSource<<54d37b535b416110ad987e74cbaa50b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RevokeClientInviteInput = {
  clientMutationId?: string | null | undefined;
  id: string;
};
export type ClientPendingMenuRevokeMutation$variables = {
  input: RevokeClientInviteInput;
};
export type ClientPendingMenuRevokeMutation$data = {
  readonly revokeClientInvite: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type ClientPendingMenuRevokeMutation = {
  response: ClientPendingMenuRevokeMutation$data;
  variables: ClientPendingMenuRevokeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RevokeClientInvitePayload",
    "kind": "LinkedField",
    "name": "revokeClientInvite",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientPendingMenuRevokeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClientPendingMenuRevokeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c477398f16c81d68d5e35fed903dc4cf",
    "id": null,
    "metadata": {},
    "name": "ClientPendingMenuRevokeMutation",
    "operationKind": "mutation",
    "text": "mutation ClientPendingMenuRevokeMutation(\n  $input: RevokeClientInviteInput!\n) {\n  revokeClientInvite(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "be287a0ee432f0f071207800365c0477";

export default node;
